import { StandardEvents } from '@shopify/events';

class QoolalaDelivery extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.generation = 0;
    const target = this.closest('.shopify-section, dialog, product-card');
    target?.addEventListener(StandardEvents.productSelect, event => this.updateVariant(event), {signal: this.controller.signal});
    this.checkExpiry();
    this.timer = setInterval(() => this.checkExpiry(), 60000);
  }
  disconnectedCallback() {
    this.controller?.abort();
    clearInterval(this.timer);
  }
  unavailable() {
    const estimate = this.querySelector('[data-delivery-estimate]');
    if (estimate) estimate.hidden = true;
    const fallback = this.querySelector('[data-delivery-unavailable]');
    if (fallback) fallback.hidden = false;
  }
  checkExpiry() {
    const expiry = Number(this.querySelector('[data-delivery-estimate]')?.dataset.expires);
    if (!expiry || Date.now() >= expiry * 1000) this.unavailable();
  }
  async updateVariant(event) {
    const card = event.target.closest?.('product-card');
    if (card && !card.contains(this)) return;
    const generation = ++this.generation;
    this.unavailable();
    try {
      const {detail} = await event.promise;
      if (generation !== this.generation || !this.isConnected) return;
      if (detail?.productId && String(detail.productId) !== this.dataset.productId) return;
      const updated = detail?.html?.getElementById(this.id);
      if (!updated || !detail.resource) return;
      this.replaceChildren(...Array.from(updated.childNodes, node => node.cloneNode(true)));
      this.checkExpiry();
    } catch {
      // Already hidden while loading; a rejected older selection must not hide a newer quote.
    }
  }
}

if (!customElements.get('qoolala-delivery')) customElements.define('qoolala-delivery', QoolalaDelivery);
